export enum PriceSourceTypeEnum {
  BCH = 'BCH',
  IHMA = 'IHMA',
}